'use strict';

import modalDirective from 'brg/rest/buttons/modal';
import resolveUsers from 'utils/resolve/users';

import template from './template.html';

export default modalDirective({
	template: template,
	controller: controller,
	resolve: {
		users: resolveUsers,
	}
});


function controller($scope, $http) {
	'ngInject';

	$scope.submitting = false;
	$scope.errors = null;
	// Initially for MVP we are not supporting designation types
	$scope.profileType = 0;
	$scope.personalPhonePolicies = [
		{value: undefined, display: 'No policy'},
		{value: 'RESPECTFUL', display: 'Respectful'},
	];
	$scope.ackRoles = [
		{value: undefined, display: 'Default'},
		{value: 'RESPONDER', display: 'Responder'},
		{value: 'SUPERVISOR', display: 'Supervisor'},
		{value: 'DISPATCHER', display: 'Dispatcher'},
	];

	$scope.submitData = function() {
		if ($scope.submitting) return;
		$scope.submitting = true;

		let url, data;

		if ($scope.profileType === 0) {
			url = '/api/escalation/create_user_profile';
			data = {
				escalation_tree: $scope.$context.escalationTree,
				user: $scope.selectedUser.uuid,
				start_seconds: $scope.startMinutes * 60,
				personal_phone_policy: $scope.personalPhonePolicy,
				ack_role: $scope.ackRole,
			};
			switch ($scope.phoneType) {
				case 0:
					data.phone_number = $scope.selectedUser.phone_number;
					break;
				case 1:
					data.phone_number = $scope.customPhoneNumber;
					break;
			}
		} else {
			return;
		}

		$http({
			method: 'POST',
			url: url,
			data: data,
		}).then((response) => {
			$scope.$close(response.data);
		}, (error) => {
			console.error(error);
			$scope.errors = error.data;
		}).finally(() => {
			$scope.submitting = false;
		});
	}
}
